import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
};

export const accessoriesRequests = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_ACCESSORIES_REQUESTS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ACCESSORIES_REQUESTS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_ACCESSORIES_REQUESTS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.FETCHING_ACCESSORIES_REQUESTS_SUMMARY]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ACCESSORIES_REQUESTS_SUMMARY]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_ACCESSORIES_REQUESTS_SUMMARY_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATING_ACCESSORIES_REQUESTS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_ACCESSORIES_REQUESTS]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATED_ACCESSORIES_REQUESTS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CLEAN_ACCESSORIES_REQUESTS_LIST]: (state, action) => ({
      ...state,
      'list': [],
    }),
  })(state, action);
};

export const accessoriesRequestsSummary = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_ACCESSORIES_REQUESTS_SUMMARY]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ACCESSORIES_REQUESTS_SUMMARY]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_ACCESSORIES_REQUESTS_SUMMARY_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
